module.exports = __webpack_public_path__ + "static/img/3_2_2.a015548b.jpg";